$(() => {
  const $dropdownElements = document.querySelectorAll('.js-kind-select');
  $dropdownElements.forEach(($dropdown, i) => {
    $($dropdown).on('change', () => {
      $('.js-update-transaction-kind').eq(i).submit();
    })
  });
});
